// src/components/modules/inventory/order/OrderHistory.jsx
import React from 'react';

function OrderHistory() {
  // Restaurant demo data
  const mockOrders = [
    {
      id: 1001,
      createdAt: new Date('2023-05-15T12:30:00').toISOString(),
      items: [
        { productId: 1, quantity: 2, price: 900 },
        { productId: 3, quantity: 1, price: 50 },
        { productId: 4, quantity: 1, price: 30.00 },
      ],
      total: 580.00,
      customerId: 2,
      status: 'completed',
      tableNumber: 5,
    },
    {
      id: 1002,
      createdAt: new Date('2023-05-15T13:15:00').toISOString(),
      items: [
        { productId: 1, quantity: 1, price: 900 },
        { productId: 2, quantity: 2, price: 300 },
        { productId: 3, quantity: 2, price: 20 },
      ],
      total: 1900,
      customerId: 1,
      status: 'completed',
      tableNumber: 3,
    },
    {
      id: 1003,
      createdAt: new Date().toISOString(),
      items: [
        { productId: 1, quantity: 1, price: 900 },
        { productId: 4, quantity: 3, price: 30.00 },
      ],
      total: 1400,
      customerId: 3,
      status: 'in-progress',
      tableNumber: 8,
    },
  ];

  const mockCustomers = [
    { id: 1, name: 'Walk-in Customer' },
    { id: 2, name: 'Mr. Rahman' },
    { id: 3, name: ' Rose traders' },
  ];

  const mockProducts = [
    { id: 1, name: 'Chicken Burger', category: 'Main' },
    { id: 2, name: 'French Fries', category: 'Side' },
    { id: 3, name: 'Soft Drink', category: 'Beverage' },
    { id: 4, name: 'Ice Cream', category: 'Dessert' },
  ];

  const getCustomerName = (customerId) => mockCustomers.find((c) => c.id === customerId)?.name || 'Walk-in';

  const formatItems = (items) => items.map((item) => {
    const product = mockProducts.find((p) => p.id === item.productId);
    return product ? `${item.quantity}x ${product.name} (৳${(item.price * item.quantity).toFixed(2)})` : 'Unknown Item';
  }).join(', ');

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Restaurant Order History</h1>
      {mockOrders.length === 0 ? (
        <p className="text-slate-900">No orders found</p>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
          <table className="min-w-full divide-y divide-slate-200">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Order #</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Table</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Customer</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Items</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Total</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-slate-900 uppercase tracking-wider">Time</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200">
              {mockOrders.map((order) => (
                <tr key={order.id} className="hover:bg-slate-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                    #
                    {order.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                    {order.tableNumber || 'Takeout'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                    {getCustomerName(order.customerId)}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-900">
                    {formatItems(order.items)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                    ৳
                    {order.total.toFixed(2)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      // eslint-disable-next-line no-nested-ternary
                      order.status === 'completed'
                        ? 'bg-green-100 text-green-800'
                        : order.status === 'in-progress'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-blue-100 text-blue-800'
                    }`}
                    >
                      {order.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                    {new Date(order.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OrderHistory;
